var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6045 3.40048C18.8577 3.65669 19 4.00415 19 4.36643C19 4.72872 18.8577 5.07617 18.6045 5.33239L8.48031 15.573C8.34652 15.7084 8.18767 15.8158 8.01285 15.889C7.83802 15.9623 7.65064 16 7.46141 16C7.27217 16 7.08479 15.9623 6.90997 15.889C6.73514 15.8158 6.5763 15.7084 6.4425 15.573L1.41236 10.486C1.28335 10.3599 1.18045 10.2092 1.10966 10.0425C1.03887 9.87578 1.00161 9.6965 1.00005 9.51509C0.998492 9.33367 1.03267 9.15376 1.10058 8.98585C1.1685 8.81794 1.2688 8.6654 1.39562 8.53711C1.52245 8.40883 1.67326 8.30738 1.83926 8.23869C2.00526 8.16999 2.18312 8.13542 2.36247 8.13699C2.54182 8.13857 2.71907 8.17626 2.88386 8.24787C3.04866 8.31947 3.1977 8.42356 3.3223 8.55405L7.46096 12.7403L16.6937 3.40048C16.8191 3.27352 16.9681 3.1728 17.132 3.10408C17.2959 3.03537 17.4716 3 17.6491 3C17.8266 3 18.0023 3.03537 18.1662 3.10408C18.3301 3.1728 18.4791 3.27352 18.6045 3.40048Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.0ba7ed386cc3b2c6072423752a9cd590.svg";
export { ForwardRef as ReactComponent };